import React, { useEffect } from "react";
import { useAuth } from "hooks/useAuth";
import { UserAvatar } from "components/UserAvatar";
import { useCountUp } from 'react-countup';
import "./ratingCounter.scss";

function RatingCounter(props) {
  const auth = useAuth();

  const { glicko, prevGlicko } = props;

  const glickoDiff = prevGlicko && (glicko - prevGlicko);

  const { countUp: glickoCountUp, update: updateGlickoCount } = useCountUp({
    start: prevGlicko ? prevGlicko : glicko,
    end: glicko,
    duration: 3,
  });

  useEffect(() => {
    const timeout = setTimeout(() => updateGlickoCount(glicko), 600);
    return () => {
      clearTimeout(timeout);
    };
  }, [glicko, updateGlickoCount]);

  return (
    <div className="rating-counter-container">
      <UserAvatar url={auth && auth.avatarUrl} />
      <div className="rating-counter">
        <div className="rating-counter-current-glicko">
          {glickoCountUp}
        </div>
        <span className={`rating-counter-glicko-diff
          ${glickoDiff > 0 ? "positive" : "negative"}`}>
          {glickoDiff && glickoDiff > 0 && "+"} {glickoDiff && glickoDiff}
        </span>
      </div>
    </div>
  );
}

export { RatingCounter };
